import {
    Toast
} from "vant";
(function(win) {
    var ratio, scaleValue, renderTime,
        htmlEle = document.documentElement,
        vpMeta = document.querySelector('meta[name="viewport"]');

    if (vpMeta) {
        var tempArr = vpMeta.getAttribute("content").match(/initial\-scale=(["']?)([\d\.]+)\1?/);
        if (tempArr) {
            scaleValue = parseFloat(tempArr[2]);
            ratio = parseInt(1 / scaleValue);
        }
    } else {
        vpMeta = document.createElement("meta");
        vpMeta.setAttribute("name", "viewport");
        vpMeta.setAttribute("content", "width=device-width, initial-scale=0.5, user-scalable=no, minimal-ui");
        htmlEle.firstElementChild.appendChild(vpMeta);
        ratio = 2;
    }

    win.addEventListener("resize", function() {
        clearTimeout(renderTime);
        renderTime = setTimeout(initPage, 300);
    }, false);

    win.addEventListener("pageshow", function(e) {
        if (e.persisted) {
            clearTimeout(renderTime);
            renderTime = setTimeout(initPage, 300)
        }
    }, false);

    if ("complete" === document.readyState) {
        document.body.style.fontSize = 12 * ratio + "px";
    } else {
        document.addEventListener("DOMContentLoaded", function() {
            document.body.style.fontSize = 12 * ratio + "px";
        }, false);
    }

    initPage();

    function initPage() {
        var htmlWidth = htmlEle.getBoundingClientRect().width;
        // htmlWidth / ratio > 768 && (htmlWidth = 768 * ratio);
        win.rem = 100 * (htmlWidth / 375);
        htmlEle.style.fontSize = win.rem + "px";
    }
})(window);



document.addEventListener('plusready', function() {
    var webview = plus.webview.currentWebview()
    plus.key.addEventListener('backbutton', function() {
        var first = null
        plus.key.addEventListener(
            'backbutton',
            function() {
                // 首次按键，提示‘再按一次退出应用’
                if (!first) {
                    first = new Date().getTime()
                        // alert('再按一次退出应用') // 此处可以用自定义提示
                    Toast('再按一次退出应用');
                    setTimeout(function() {
                        first = null
                    }, 1000)
                } else {
                    if (new Date().getTime() - first < 1500) {
                        plus.runtime.quit()
                    }
                }
            },
            false
        )

        // webview.canBack(function(e) {
        // if (e.canBack) {
        //     webview.back()
        // } else {
        //     // webview.close() //hide,quit
        //     // plus.runtime.quit()
        //     // 首页返回键处理
        //     // 处理逻辑：1秒内，连续两次按返回键，则退出应用；
        //     var first = null
        //     plus.key.addEventListener(
        //         'backbutton',
        //         function() {
        //             // 首次按键，提示‘再按一次退出应用’
        //             if (!first) {
        //                 first = new Date().getTime()
        //                     // alert('再按一次退出应用') // 此处可以用自定义提示
        //                 Toast('再按一次退出应用');
        //                 setTimeout(function() {
        //                     first = null
        //                 }, 1000)
        //             } else {
        //                 if (new Date().getTime() - first < 1500) {
        //                     plus.runtime.quit()
        //                 }
        //             }
        //         },
        //         false
        //     )
        // }
        // })
    })
})


//////////////////
// WEBPACK FOOTER
// ./htm.js
// module id = null
// module chunks = 